import { RESPONSE_CHOICES } from "../../constants"

export default class QuestionnaireUtils {
  static isCommentRequired(responseChoice?: string) {
    if (!responseChoice) return false
    return (
      responseChoice === RESPONSE_CHOICES.NA ||
      responseChoice === RESPONSE_CHOICES.Partial
    )
  }
}
